<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Award Points Details</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link :to="{ name: 'award-points' }">Award Points</router-link>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">

            <label class="card-title font-weight-bold">Awardee Details</label>

            <br/>

            <div class="row">
              <div class="col-6">
                <label style="font-weight: bold;">My Takaful ID: </label>
                <label class="ml-2" style="font-weight: bold;">{{data.customer.account_number}}</label>
              </div>
              <div class="col-6">
                <label>Points Earned: </label>
                <label class="ml-2">{{data.point}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label>IC Number: </label>
                <label class="ml-2">{{data.customer.ic_number}}</label>
              </div>
              <div class="col-6">
                <label>Date Earned: </label>
                <label class="ml-2">{{data.created_at}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label>Name: </label>
                <label class="ml-2">{{data.customer.name}}</label>
              </div>
              <div class="col-6">
                <label>Expiry Date: </label>
                <label class="ml-2">{{data.expiry_date}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label>Mobile No: </label>
                <label class="ml-2">{{data.customer.mobile_number}}</label>
              </div>
              <div class="col-6">
                <label>Description: </label>
                <label class="ml-2">{{data.description}}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label>Email: </label>
                <label class="ml-2">{{data.customer.email}}</label>
              </div>
              <div class="col-6">
                <label>Awarded by: </label>
                <label class="ml-2">{{data.awarded_by.name}}</label>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import "vue-select/dist/vue-select.css";
import { getRequest } from "@/services/RequestService";

export default {
  name: "award-points-details",
  mixins: [dateManipulation],
  components: {  },

  data() {
    return {
      data: {
        id: null,
        description: null,
        point: null,
        expiry_date: null,
        created_at: null,
        customer: {
          id: null,
          name: null,
          ic_number: null,
          email: null,
          mobile_number: null,
          account_number: null,
          email: null
        },
        awarded_by: {
          id: null,
          name: null
        }
      },
      award_id: this.$route.params.id,

      
    };
  },

  methods: {
    async loadDetails() {
      try {
        let res = await getRequest(`${axios.lpsURL}/award/view/${this.award_id}`);
        this.data = res.data.success ? res.data.data : { id: null, description: null, point: null, expiry_date: null, created_at: null, customer: {id: null, name: null, ic_number: null, email: null, mobile_number: null, account_number: null,}, awarded_by: { id: null, name: null } };
      } catch (e) {
        console.log(e)
      }
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    this.loadDetails();
  }
};
</script>
